// extracted by mini-css-extract-plugin
export default {"noWrap":"DetectedSets_noWrap__rHVMu","largePopover":"DetectedSets_largePopover__Qo20L","stickySearch":"DetectedSets_stickySearch__2oQ8u","popover":"DetectedSets_popover__tCFBO"};